<template>
    <div class="progressContainer">
        <template v-if="use == 0 && free == 0">
            <div class="use full" style="width: 100%"></div>
        </template>
        <template v-else-if="use == 0 && free != 0">

            <div class="free full" style="width: 100%"></div>
        </template>
        <template v-else>
            <div class="use" :style="{ width: (use / (use + free)) * 100 + '%' }" :class="{ full: use >= 100 }"></div>
            <div class="free" :style="{ width: (free / (use + free)) * 100 + '%' }" :class="{ full: free >= 100 }"></div>
        </template>
    </div>
</template>
<script>
export default {
    props: ['use', 'free'],
}
</script>
<style lang='less' scoped>
.progressContainer {
    // background-color: white;
    height: 10px !important;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    width: 100% !important;
    margin-top: 10px;

    .use {
        background-color: #ff5a5a;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .free {
        background-color: #7bd387;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .full {
        border-radius: 5px;
    }
}

.progressContainer {
    width: 110px;
    background-color: white;
    height: 5px;
}

.progress {
    height: 100%;
    background: -webkit-linear-gradient(left, #396c9f, #334d8d);
    float: left;
}
</style>
  


// WEBPACK FOOTER //
// src/components/progress.vue